const PhoneViewModel = function (data) {
    if (!data) data = {};
    this.type = data.type || null;
    this.countryCode = data.countryCode || null;
    this.countryIso = data.countryIso || null;
    this.number = data.number || null;
  };
  export default PhoneViewModel;
  